import React from 'react'
import PropTypes from 'prop-types'

class CellarHeader extends React.Component {
  render() {
    const { cellarTitle, cellarDescription, imageUrl, cellarUrl } = this.props

    return (
      <div className="space--both-2">
        <div className="grid">
          {
            imageUrl ?
              (<div className="grid__item eq-palm-fill tab-4-12 lap-3-12 align--center">
                <a href={ cellarUrl || undefined } target="_blank" rel="noreferrer">
                  <img src={ imageUrl } className="cellar-header__logo" />
                </a>
              </div>)
              :
              ''
          }
          <div className="grid__item eq-palm-fill tab-8-12 lap-9-12 desk-7-12">
            <div className="space--both-2">
              <h1 className="cellar-header__title beta">
                { cellarTitle }
              </h1>
            </div>
            <div className="cellar-header__description" dangerouslySetInnerHTML={{ __html: cellarDescription || '' }}></div>
          </div>
        </div>
      </div>
    )
  }
}

CellarHeader.propTypes = {
  cellarTitle: PropTypes.string.isRequired,
  cellarDescription: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  cellarUrl: PropTypes.string,
}

export default CellarHeader
